export default __webpack_public_path__ + "static/delta-lake-logo-a1c0d80d23c17de5f5d7224cb40f15dc.svg";